export default __webpack_public_path__ + "static/media/404.5bddff0d.png";